import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import bg from '../../images/offer-bg.webp'
import infra from "../../images/it.jpg"
import { useMediaQuery } from 'react-responsive';


const Offer = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <div className='offer-section section-padding position-relative'
        //  style={{ backgroundImage: `url(${infra})` }}
         >
            <Container>
                <Row>
                {
                         isMobile &&
                         <Col lg={6}>
                         <img className='infrsimage' src={infra}></img>
                         </Col>
                    }
                    <Col lg={6}>
                        <div className='position-relative offercontent'>
                            <h2 className={`text-capitalize ${isMobile ? 'mb-2': 'mb-4'}`}>IT Consulting</h2>
                            <h6 className='text-capitalize'>In today’s digital world, we help businesses stay ahead by providing cutting-edge IT consulting services. From cloud solutions to enterprise IT strategy, VeeraSynergies drives innovation to help you achieve your goals.
                            </h6>
                          
                        </div>
                    </Col>
                    {
                         !isMobile &&
                         <Col lg={6}>
                         <img className='infrsimage' src={infra}></img>
                         </Col>
                    }
                </Row>
            </Container>
        </div>
    )
}

export default Offer
